export default "__VITE_ASSET__UFkXiotv__"